var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBaselinePhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.86167 6.29417C4.70167 7.945 6.055 9.2925 7.70583 10.1383L8.98917 8.855C9.14667 8.6975 9.38 8.645 9.58417 8.715C10.2375 8.93083 10.9433 9.0475 11.6667 9.0475C11.9875 9.0475 12.25 9.31 12.25 9.63083V11.6667C12.25 11.9875 11.9875 12.25 11.6667 12.25C6.18917 12.25 1.75 7.81083 1.75 2.33333C1.75 2.0125 2.0125 1.75 2.33333 1.75H4.375C4.69583 1.75 4.95833 2.0125 4.95833 2.33333C4.95833 3.0625 5.075 3.7625 5.29083 4.41583C5.355 4.62 5.30833 4.8475 5.145 5.01083L3.86167 6.29417Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBaselinePhone);
export default __webpack_public_path__ + "static/media/ic_baseline-phone.36f71dd8ca526e294606c2ce4bd47351.svg";
export { ForwardRef as ReactComponent };